import React from "react";

export function MydawaLogo({ className = "h-10", testId = "mydawa-logo" }) {
  return (
    <img
      src="/brand/mydawa-logo.png"
      alt="MYDAWA — we deliver care"
      className={`${className} w-auto object-contain`}
      data-testid={testId}
    />
  );
}
